<ng-container *transloco="let t">
  <authority-labs-base-dialog [dialogRef]="dialogRef" [title]="title">
    <div content>
      <div>
        <h3 class="table-title">הזמנות תחת אותו ההסכם - {{ subProjectId }}</h3>
        <nz-table
          nzSize="small"
          [nzShowPagination]="false"
          [nzLoading]="isLoading[subProjectId]"
          nzTemplateMode
        >
          <thead>
            <tr>
              <th></th>
              <th>מס' הזמנה</th>
              <th>מס' הסכם</th>
              <th>שם הפרוייקט</th>
              <th>סוג הבדיקה</th>
              <th>תאריך הבדיקה</th>
              <th>שם הבודק</th>
              <th>חברה מזמינה</th>
              <th>סטטוס</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of inspectionInSameSubproject">
              <td>
                <mat-radio-button (change)="onSelect(item)"> </mat-radio-button>
              </td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.subProjectId }}</td>
              <td>{{ item.subProjectName }}</td>
              <td>{{ item.inspectionType }}</td>
              <td>{{ item.inspectionDate | date }}</td>
              <td>{{ item.assignee | username }}</td>
              <td>{{ item.company }}</td>
              <td>{{ item.status }}</td>
              <td>
                <button
                  nz-button
                  nzGhost
                  nzType="primary"
                  type="button"
                  (click)="openCertificateDialog(item.orderId)"
                  *ngIf="item.inspectionId && item.inspectionDate"
                >
                  תעודה
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <div class="lower" *ngIf="parentSubProjectId">
        <h3 class="table-title">
          הזמנות תחת ההסכם המקורי - {{ parentSubProjectId }}
        </h3>
        <nz-table
          nzSize="small"
          [nzShowPagination]="false"
          [nzLoading]="isLoading[parentSubProjectId]"
          nzTemplateMode
        >
          <thead>
            <tr>
              <th></th>
              <th>מס' הזמנה</th>
              <th>מס' הסכם</th>
              <th>שם הפרוייקט</th>
              <th>סוג הבדיקה</th>
              <th>תאריך הבדיקה</th>
              <th>שם הבודק</th>
              <th>חברה מזמינה</th>
              <th>סטטוס</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of inspectionInParentSubproject">
              <td>
                <mat-radio-button (change)="onSelect(item)"> </mat-radio-button>
              </td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.subProjectId }}</td>
              <td>{{ item.subProjectName }}</td>
              <td>{{ item.inspectionType }}</td>
              <td>{{ item.inspectionDate | date }}</td>
              <td>{{ item.assignee | username }}</td>
              <td>{{ item.company }}</td>
              <td>{{ item.status }}</td>
              <td>
                <button
                  nz-button
                  nzGhost
                  nzType="primary"
                  type="button"
                  (click)="openCertificateDialog(item.orderId)"
                  *ngIf="item.inspectionId && item.inspectionDate"
                >
                  תעודה
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <div class="lower" *ngIf="allShown">
        <h3 class="table-title">הזמנות תחת אותו הפרוייקט - {{ projectId }}</h3>
        <nz-table
          nzSize="small"
          [nzShowPagination]="false"
          [nzLoading]="isLoading[projectId]"
          nzTemplateMode
        >
          <thead>
            <tr>
              <th></th>
              <th>מס' הזמנה</th>
              <th>מס' הסכם</th>
              <th>שם הפרוייקט</th>
              <th>סוג הבדיקה</th>
              <th>תאריך הבדיקה</th>
              <th>שם הבודק</th>
              <th>חברה מזמינה</th>
              <th>סטטוס</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of inspectionInSameProject">
              <td>
                <mat-radio-button (change)="onSelect(item)"> </mat-radio-button>
              </td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.subProjectId }}</td>
              <td>{{ item.subProjectName }}</td>
              <td>{{ item.inspectionType }}</td>
              <td>{{ item.inspectionDate | date }}</td>
              <td>{{ item.assignee | username }}</td>
              <td>{{ item.company }}</td>
              <td>{{ item.status }}</td>
              <td>
                <button
                  nz-button
                  nzGhost
                  nzType="primary"
                  type="button"
                  (click)="openCertificateDialog(item.orderId)"
                  *ngIf="item.inspectionId && item.inspectionDate"
                >
                  תעודה
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>

    <button
      actions
      nz-button
      (click)="chooseAndClose()"
      *ngIf="selectedInspectionId"
      style="margin-left: 10px"
    >
      בחר
    </button>
    <button actions nz-button (click)="loadAllInspections()" *ngIf="!allShown">
      טען הזמנות מכל הפרוייקט
    </button>
  </authority-labs-base-dialog>
</ng-container>
